export class HeaderNav {
	navSelector = '.js-header-nav';
	dropdownSelector = '.js-dropdown';

	constructor() {
		this.init();
	}

	init() {
		this.nav = document.querySelector(this.navSelector);
		if (!this.nav) return;

		this.dropdowns = this.nav.querySelectorAll(this.dropdownSelector);
		this.mqHover = window.matchMedia('(hover: hover)');

		this.bindEvents();
	}

	handleMouseEnter = (instance) => {
		this.mqHover.matches && instance.dropdown.open();
	};

	handleMouseLeave = (instance) => {
		this.mqHover.matches && instance.dropdown.close();
	};

	bindEvents() {
		this.dropdowns.forEach((dropdown) => {
			const instance = app.classInstance.get(dropdown);
			if (!instance) return;

			dropdown.addEventListener('mouseenter', () => this.handleMouseEnter(instance));
			dropdown.addEventListener('mouseleave', () => this.handleMouseLeave(instance));
		});
	}
}
